import {I_ACCESS_TOKEN_PARAMS,I_COMMON_DELETE_PARAMS,I_COMMON_GET_ITEM_PARAMS,_customFetch, getFetchGETOptions} from './_base';
import LoggerService,{formatTrace} from '../../LoggerService';
import APP_CONFIG from 'config';

// ---------------------------------
// --- LOGS
// ---------------------------------

const ENDPOINT_LOGS = '/logs';

const logger = LoggerService.getInstance();

// valeurs pour entity_type : billing_customers charge collaborators skills activity_types task_types users activities


interface I_GET_PARAMS extends I_ACCESS_TOKEN_PARAMS {
  id: number;
  from_date?: string;
  to_date?: string;
  action?: string[];
  user?: number;
}

/** Formate les parametres à passer aux requetes */
const formatLogsQuery = ({
  page,from_date,to_date,action,user,
}:{
  page?:number,from_date?: string,to_date?: string,action?: string[],user?:number,
}) => {
  const paramPage = `${page ? '&page=' + page : ''}`;
  const paramFromDate = `${from_date ? 'from_date='+from_date : ''}`;
  const paramToDate = `${to_date ? 'to_date='+to_date : ''}`;
  const paramAction = `${action ? 'action='+action?.join(',') : ''}`;
  const paramUser = `${user ? 'user='+user : ''}`;
  const paramsAll = [paramFromDate,paramToDate,paramAction,paramUser].join('&');
  return `${paramsAll}${paramPage}`;
};

/**
 * Requete le endpoint
 * Récupère la liste des logs
 * @param param0
 */
const getCharge = async ({
  accessToken,
  id,
  page,
  from_date,to_date,action,user,
}:I_GET_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - logs - getCharge...'));
  const options = getFetchGETOptions({accessToken});
  const query = formatLogsQuery({page,from_date,to_date,action,user});
  const URL = `${ENDPOINT_LOGS}/entity/charge/${id}${APP_CONFIG.ENDPOINT_SUFFIX}?${query}`;
  return _customFetch(URL,options);
};
/**
 * Requete le endpoint
 * Récupère la liste des logs
 * @param param0
 */
const getActivity = async ({
  accessToken,
  id,
  page,
  from_date,to_date,action,user,
}:I_GET_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - logs - getActivity...'));
  const options = getFetchGETOptions({accessToken});
  const query = formatLogsQuery({page,from_date,to_date,action,user});
  const URL = `${ENDPOINT_LOGS}/entity/activities/${id}${APP_CONFIG.ENDPOINT_SUFFIX}?${query}`;
  return _customFetch(URL,options);
};

/**
 * Requete le endpoint
 * Récupère la liste des logs
 * @param param0
 */
const getCollaborator = async ({
  accessToken,
  id,
  page,
  from_date,to_date,action,user,
}:I_GET_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - logs - getCollaborator...'));
  const options = getFetchGETOptions({accessToken});
  const query = formatLogsQuery({page,from_date,to_date,action,user});
  const URL = `${ENDPOINT_LOGS}/entity/collaborators/${id}${APP_CONFIG.ENDPOINT_SUFFIX}?${query}`;
  return _customFetch(URL,options);
};

/**
 * Requete le endpoint
 * Récupère la liste des logs
 * @param param0
 */
const getCustomer = async ({
  accessToken,
  id,
  page,
  from_date,to_date,action,user,
}:I_GET_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - logs - getCustomer...'));
  const options = getFetchGETOptions({accessToken});
  const query = formatLogsQuery({page,from_date,to_date,action,user});
  const URL = `${ENDPOINT_LOGS}/entity/audited_customers/${id}${APP_CONFIG.ENDPOINT_SUFFIX}?${query}`;
  return _customFetch(URL,options);
};

// todo : billing_customers skills activity_types task_types users

const logsEndpoints = {
  getCharge,
  getActivity,
  getCollaborator,
  getCustomer,
};

export default logsEndpoints;
